import { ReactNode, createContext, useContext, useState, useEffect } from 'react';
import { LeftNav } from './LeftNav';

interface SidebarContextType {
  collapsed: boolean;
  toggle: () => void;
}

const SidebarContext = createContext<SidebarContextType>({ collapsed: false, toggle: () => {} });

export function useSidebar() {
  return useContext(SidebarContext);
}

const SIDEBAR_KEY = 'athen-sidebar-collapsed';

export function AppShell({ children }: { children: ReactNode }) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(SIDEBAR_KEY) === 'true';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try { localStorage.setItem(SIDEBAR_KEY, String(collapsed)); } catch {}
  }, [collapsed]);

  const toggle = () => setCollapsed(prev => !prev);

  return (
    <SidebarContext.Provider value={{ collapsed, toggle }}>
      <div className="min-h-screen bg-neutral-50 flex">
        <aside
          className={`bg-white border-r border-neutral-200 shadow-nav hidden md:flex flex-col transition-all duration-200 ${
            collapsed ? 'w-[60px]' : 'w-[240px]'
          }`}
        >
          <div className="w-full h-screen sticky top-0 flex flex-col">
            <LeftNav collapsed={collapsed} onToggle={toggle} />
          </div>
        </aside>
        <main className="flex-1 min-w-0">
          {children}
        </main>
      </div>
    </SidebarContext.Provider>
  );
}
